import * as S from './styles';

import { MediaMatch } from '../../../MediaMatch';
import { Skeleton } from '../../../Skeleton';
import { Typography } from '../../../Typography';

import { formatGtm } from '../../../../../utils/formatGtm';

import { CardPrimaryProps } from './types';
export const CardPrimary = ({
	primaryCardTitle = 'Seguro completo para o seu celular',
	primaryCardMobileImg = 'https://via.placeholder.com/186x288',
	primaryCardLandscapeImg = 'https://via.placeholder.com/390x186',
	primaryCardPortrailImg = 'https://via.placeholder.com/280x186',
	primaryCardDesktopImg = 'https://via.placeholder.com/342x448',
	primaryCardUltraWideImg = 'https://via.placeholder.com/592x453',
	primaryCardText = 'Eu quero',
	primaryCardLinkUrl = '',
	mode = 'light',
	isLoading = false,
	headingCardPrimary,
	gtmName,
}: CardPrimaryProps) => {
	return (
		<>
			{isLoading ? (
				<>
					<MediaMatch lessThan="desktop">
						<S.Container mode={mode}>
							<S.Heading mode={mode}>
								<Skeleton width={95} height={4} />
							</S.Heading>
							<div
								style={{
									marginBottom: '24px',
								}}
							>
								<Skeleton width={100} height={18.6} borderRadius={1.6} />
							</div>
							<S.TextShimmer mode={mode}>
								<Skeleton width={100} height={2.6} />
							</S.TextShimmer>
						</S.Container>
					</MediaMatch>
					<MediaMatch greaterThan="desktop">
						<S.Container mode={mode}>
							<S.Heading mode={mode}>
								<Skeleton width={95} height={2.6} />
							</S.Heading>
							<div
								style={{
									marginBottom: '24px',
								}}
							>
								<Skeleton width={100} height={34.2} borderRadius={1.6} />
							</div>
							<S.TextShimmer mode={mode}>
								<Skeleton width={100} height={3.2} />
							</S.TextShimmer>
						</S.Container>
					</MediaMatch>
				</>
			) : (
				<S.Link
					as="a"
					href={primaryCardLinkUrl}
					role="card-primary-link"
					data-gtm-type="click"
					data-gtm-clicktype="card"
					data-gtm-name={formatGtm(gtmName)}
					data-gtm-subname={`${formatGtm(primaryCardTitle)}:${formatGtm(
						primaryCardText
					)}`}
				>
					<S.Container role="card-primary" mode={mode}>
						<S.Heading tabIndex={0} mode={mode}>
							<Typography
								as={headingCardPrimary}
								type="Title6"
								weight="medium"
								color="portoSeguros100"
							>
								{primaryCardTitle}
							</Typography>
						</S.Heading>
						<picture>
							<source
								media="(min-width:1600px)"
								srcSet={primaryCardUltraWideImg}
							/>
							<source
								media="(min-width:1224px)"
								srcSet={primaryCardDesktopImg}
							/>
							<source
								media="(min-width:1024px)"
								srcSet={primaryCardLandscapeImg}
							/>
							<source
								media="(min-width:768px)"
								srcSet={primaryCardPortrailImg}
							/>
							<S.Image
								width={256}
								height={196}
								src={primaryCardMobileImg}
								alt={primaryCardTitle}
								loading="lazy"
							/>
						</picture>
						<S.Text mode={mode} tabIndex={0}>
							{primaryCardText}
						</S.Text>
					</S.Container>
				</S.Link>
			)}
		</>
	);
};
